import RadialProgress from 'common/components/RadialProgress'

const formatNumber = (num: number): string => {
  return num.toLocaleString('en-US')
}

interface Props {
  value: number
  label: string
  counter?: {
    value: number
    goal: number
  }
}

const MilestoneItem = ({ value, label, counter }: Props) => (
  <div className="flex items-center gap-3 min-h-9 text-xs">
    <RadialProgress value={value} size="sm" className="flex-shrink-0" />
    <div className="flex flex-wrap">
      <span className="text-base-700 mr-2.5">{label}</span>
      {counter && (
        <span className="text-gold-600 whitespace-nowrap">
          {formatNumber(counter.value)} / {formatNumber(counter.goal)}
        </span>
      )}
    </div>
  </div>
)

export default MilestoneItem
